<template>
  <section class="container">
    <div class="is-flex is-justify-content-center is-align-content-center">
        <div v-animate-css="'fadeIn'">
          <SVGWhosTraveling class="mt-6 pt-6"/>
        </div>
      <div>
          <TravellerModal :profile="this.$globals.profile" style="min-width: 400px;"/>
      </div>
    </div>
  </section>
</template>

<script>
  import TravellerModal from "../Traveller/TravellerModal";
  import SVGWhosTraveling from "../SVGs/SVG-WhosTraveling";

  export default {
    name: "WhosTraveling",
    components: {
      TravellerModal,
      SVGWhosTraveling,
    },
    data() {
      return {
      }
    },
    methods:{
    },
    mounted() {
    }
  }
</script>

<style scoped>
</style>